module.exports = __webpack_public_path__ + "img/solution29.6741c94c.png";